var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBlik = function SvgBlik(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "21px",
    viewBox: "0 0 40 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home",
    transform: "translate(-1677.000000, -2883.000000)",
    fill: "#DADADA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stopka",
    transform: "translate(0.000000, 2830.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-bia\\u0142e",
    transform: "translate(1494.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.842912,2.70192724 L186.842912,9.76180165 C187.730256,9.29114335 188.721992,9.02966652 189.818122,9.02966652 C193.263102,9.02966652 196.029525,11.8536163 196.029525,15.2528151 C196.029525,18.7043092 193.263102,21.528259 189.818122,21.528259 C186.373142,21.528259 183.554523,18.7043092 183.554523,15.2528151 L183.554523,15.2528151 L183.554523,2.70192724 L186.842912,2.70192724 Z M201.614567,2.70192724 L201.614567,21.3713729 L198.326178,21.3713729 L198.326178,2.70192724 L201.614567,2.70192724 Z M207.82597,9.18655262 L207.82597,21.3713729 L204.53758,21.3713729 L204.53758,9.18655262 L207.82597,9.18655262 Z M222.336642,9.18655262 L217.743336,14.7821568 L222.858608,21.3713729 L218.630679,21.3713729 L213.985176,14.8344521 L218.526285,9.18655262 L222.336642,9.18655262 Z M213.985176,2.70192724 L213.985176,21.3713729 L210.696786,21.3713729 L210.696786,2.70192724 L213.985176,2.70192724 Z M189.818122,12.2719792 C188.147829,12.2719792 186.790716,13.6316587 186.790716,15.2528151 C186.790716,16.9262668 188.147829,18.2859463 189.818122,18.2859463 C191.436219,18.2859463 192.793332,16.9262668 192.793332,15.2528151 C192.793332,13.6316587 191.436219,12.2719792 189.818122,12.2719792 Z M193.106512,1.76061065 C194.724608,1.76061065 196.029525,3.12029017 196.029525,4.74144651 C196.029525,6.36260286 194.724608,7.66998701 193.106512,7.66998701 C191.488415,7.66998701 190.183499,6.36260286 190.183499,4.74144651 C190.183499,3.12029017 191.488415,1.76061065 193.106512,1.76061065 Z",
    id: "blik"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBlik, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/blik.972720fc.svg";
export { ForwardRef as ReactComponent };